module.exports = __webpack_public_path__ + "static/media/login.fc0b7b37.png";